import React, { useState } from 'react';
import {
    MDBTabs,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsContent,
    MDBTabsPane, MDBIcon
} from 'mdb-react-ui-kit';
import {Content} from "antd/es/layout/layout";
import {Layout} from "antd";
import QrEventTable from "./component/QrEventTable";
import ParticipantTable from "./component/QrEventParticipantsTable";

export default function QrEventAdminListPage() {
    const [fillActive, setFillActive] = useState('tab1');

    const handleFillClick = (value: string) => {
        if (value === fillActive) {
            return;
        }
        setFillActive(value);
    };

    const handleAttendanceClick = () => {
        window.open(
            "/qr-event-participant-attendance",
            "_blank",
            "noopener,noreferrer"
        );
    };

    return (
        <Layout style={{ backgroundColor: '#fff'}}>
            <Content className='page-content'>
                <MDBTabs fill className='mb-3'>
                    <MDBTabsItem>
                        <MDBTabsLink style={{fontSize: "16px"}} onClick={() => handleFillClick('tab1')} active={fillActive === 'tab1'}>
                            <MDBIcon fas icon='cogs' className='me-2' /> 행사 관리
                        </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                        <MDBTabsLink style={{fontSize: "16px"}} onClick={() => handleFillClick('tab2')} active={fillActive === 'tab2'}>
                            <MDBIcon fas icon='cogs' className='me-2' /> 참가자 관리
                        </MDBTabsLink>
                    </MDBTabsItem>
                    <MDBTabsItem>
                        <MDBTabsLink
                            style={{ fontSize: "16px", color: "#d32f2f" }}
                            onClick={handleAttendanceClick}
                        >
                            <MDBIcon fas icon="qrcode" className="me-2" />
                            입/퇴장 RFID 출석체크 시스템 입장
                        </MDBTabsLink>
                    </MDBTabsItem>
                </MDBTabs>

                <MDBTabsContent>
                    {/* tab1 활성화 시 QrEventTable 렌더링 */}
                    <MDBTabsPane open={fillActive === 'tab1'}>
                        {fillActive === 'tab1' && <QrEventTable key="event-table" />}
                    </MDBTabsPane>

                    {/* tab2 활성화 시 ParticipantTable 렌더링 */}
                    <MDBTabsPane open={fillActive === 'tab2'}>
                        {fillActive === 'tab2' && <ParticipantTable key="participant-table" />}
                    </MDBTabsPane>
                </MDBTabsContent>
            </Content>
        </Layout>
    );
}